class LocalIdService {
  _id: number = 0;

  nextId() {
    return --this._id;
  }
}

export default new LocalIdService();
